module.exports = __webpack_public_path__ + "assets/img/title.bea120a2.png";